import type { ApiPortfolioManagementModes } from './contract.types'

export const CONTRAT_LINE_TYPES = {
  MANDATS: 'Mandats',
  PROFILS: 'Profils',
  VOID: '',
} as const
export type ContratLineType = ValueOf<typeof CONTRAT_LINE_TYPES>

export const DELEGATED_CONTRACT_LINE_TYPES = new Set<ContratLineType>([
  CONTRAT_LINE_TYPES.MANDATS,
  CONTRAT_LINE_TYPES.PROFILS,
])

export type ContractLineBase = {
  isin: string
  name: string | null
  amount: number
  amount_initial: number
  deposit: number
  withdrawal: number
  weight: number
  monthly_amount_initial: number
  monthly_amount: number
  monthly_buyout_initial: number
  srri: number
  id?: string
}

export type ContractLine = ContractLineBase & {
  pdf_url: null | string
  max_initial_payment: null | number
  max_scheduled_payment: null | number
  min_initial_payment: null | number
  min_scheduled_payment: null | number
  is_only_to_insured?: boolean
  is_eligible_with_mandats?: boolean
  is_arbitrable?: boolean
  management_type?: ApiPortfolioManagementModes
  type: ContratLineType
  isReadonly?: boolean
  contractManagementType?: ApiPortfolioManagementModes
  contractManagementTypeInitial?: ApiPortfolioManagementModes
}
